export default function maInputArray($location, $filter) {
    return {
        scope: {
            item: '='
        },
        link: function (scope, element) {
            let controller = scope.$root;

            scope.focusSection = function () {
                //controller.toggle_open = null;
                controller.current_page = scope.item;
            };
            scope.isActive = function(){
                if(scope.item.isActive($location.absUrl())){
                    controller.current_page = scope.item;
                    return scope.item.isActive($location.absUrl());
                }

                return controller.current_page === scope.item;
            };
            scope.link = function(link){

                link = $filter('translate')(link);

                if(link.indexOf('http') > -1){
                    return link
                }else{
                    return '#' + link;
                }
            }
            scope.target = function(link){
                link = $filter('translate')(link);

                if(link.indexOf('http') > -1){
                    return '_blank';
                }
            }
        },
        template: `
            <md-button ui-sref-active="active" href="{{ link(item._link) }}" target="{{ target(item._link) }}" ng-click="focusSection()" ng-class="{'active': isActive()}">
                <span ng-bind-html="item._icon"></span>
                {{ item._title | translate }}
            </md-button>
        `
    };
};

maInputArray.$inject = ['$location', '$filter'];


/** WEBPACK FOOTER **
 ** ./js/directives/menu_link.js
 **/